import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'
import queryString from 'query-string'

// components
import { Size, Color } from '../../../../../const'
import Alert from 'components/Alert'

// hooks
import { useLoginCallbackHook } from 'hooks'
import { useLocation, useHistory } from 'react-router-dom'

function Login({ qs }) {
  const history = useHistory()
  const search = useLocation().search
  const [values] = useState(queryString.parse(search))

  const [isRedirectErrorOpen, setIsRedirectErrorOpen] = useState(qs.redirected === 'true')
  const {
    loginErrors,
    setLoginErrors,
    isLoginSuccess,
    execLogIn,
    resetStorageFunc,
    isSwitched,
    isAgreement,
  } = useLoginCallbackHook()

  useEffect(() => {
    const logIn = async () => {
      if (_.isEmpty(values)) {
        return
      }
      await execLogIn(values)
    }

    logIn()
  }, [values, execLogIn])

  useEffect(() => {
    if (isLoginSuccess) {
      /* 登録されていなければtanakaIdの変更画面へ */
      if (!isSwitched) {
        history.push('/tanakaid/switch')

        return
      }

      /* 登録が済んでいるが,規約に同意していない場合は、規約ページに遷移 */
      if (!isAgreement) {
        history.push('/signup')

        return
      }
      /* 上記が満たされれば会員ページTOPへ */
      history.push('/top')
    }
  }, [isLoginSuccess, history, isSwitched, isAgreement])

  useEffect(() => {
    if (qs.redirected === 'true') {
      resetStorageFunc()
    }
  }, [qs.redirected, resetStorageFunc])

  return (
    <Wrapper>
      {loginErrors.length > 0 && (
        <Alert type="error" message="エラー" description={loginErrors.join('\n')} onClose={() => setLoginErrors([])} />
      )}
      {isRedirectErrorOpen && (
        <Alert
          type="error"
          message="エラー"
          description="APIキーが無効であるため、ログアウトされました"
          onClose={() => setIsRedirectErrorOpen(false)}
        />
      )}
      <TitleBlock>ログイン中</TitleBlock>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const TitleBlock = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.HEADLINE.SMALL};
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #ccc;
`

Login.propTypes = {
  qs: PropTypes.object,
}

export default Login
